/**
 * [Insider+] Deep-link path validation.
 */

const MAX_PATH_LENGTH = 2048;

// Reject absolute URLs, protocol-relative URLs, and anything that could
// resolve outside INSIDER_PLUS_BASE_URL when concatenated into the iframe src.
export const isSafeInsiderPlusPath = (value) => {
  if (typeof value !== 'string') return false;
  if (value.length === 0 || value.length > MAX_PATH_LENGTH) return false;
  if (!value.startsWith('/')) return false;
  if (value.startsWith('//')) return false;
  if (value.includes('://')) return false;
  if (value.includes('\\')) return false;
  return true;
};
